import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueMeta from 'vue-meta'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
Vue.use(VueMeta);
Vue.config.productionTip = false
if (localStorage.getItem('lang') === 'ar') {
	require('bootstrap/dist/css/bootstrap.rtl.min.css'); 
} else {
	require('bootstrap/dist/css/bootstrap.min.css');
}
new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app')
